/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter, useParams, useHistory } from "react-router-dom";
import Page from "components/common_components/Page/Page";
import { useDispatch } from "react-redux";
import { notifyError, notifySuccess } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import Form from "./Form";
import SettingsContext from "../SettingsContext";
import Header from "components/common_components/Header";

function Flow(props) {
    const history = useHistory();
    const { id } = useParams();
    const [flow, setFlow] = useState(undefined);
    const [resources, setResources] = useState({ modules: [], types: [], users: [] });
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const { mode } = props;

    const { Flows, Modules, Types, Users } = useContext(SettingsContext);

    function getFlow() {
        setIsLoading(true);
        Flows.getOneById({
            id,
            onSuccess: (data) => {
                setFlow(data);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    }

    function getModules() {
        setIsLoading(true);
        Modules.getAll({
            onSuccess: (data) => {
                setResources((prev) => ({
                    ...prev,
                    modules: data,
                }));
                setIsLoading(false);
            },
            onError: (error) => {
                setResources((prev) => ({
                    ...prev,
                    modules: [],
                }));
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    }

    function getTypes() {
        setIsLoading(true);
        Types.getAll({
            onSuccess: (data) => {
                setResources((prev) => ({
                    ...prev,
                    types: data,
                }));
                setIsLoading(false);
            },
            onError: (error) => {
                setResources((prev) => ({
                    ...prev,
                    types: [],
                }));
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    }

    function getUsers() {
        setIsLoading(true);
        Users.getAll({
            onSuccess: (data) => {
                setResources((prev) => ({
                    ...prev,
                    users: data,
                }));
                setIsLoading(false);
            },
            onError: (error) => {
                setResources((prev) => ({
                    ...prev,
                    users: [],
                }));
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    }

    useEffect(() => {
        if (id) {
            getFlow();
        }
    }, [id]);

    useEffect(() => {
        getModules();
        getTypes();
        getUsers();
    }, []);

    function onEditHandler() {
        history.push(`/settings/flows/${id}/update`);
    }

    function onCancelHandler() {
        history.push(`/settings/flows`);
    }

    function onSuccess(response, setSubmitting) {
        setSubmitting(false);
        dispatch(notifySuccess(`Flow ${mode === "add" ? "created" : "updated"} successfully!`));
        history.push(`/settings/flows/${response}`);
    }

    function onError(error, setSubmitting, setErrors) {
        if (error && error.errors) {
            setErrors(error.errors);
            dispatch(notifyError(error.message));
        } else {
            onCancelHandler();
            dispatch(notifyError(error));
        }
        setSubmitting(false);
    }

    function onSubmitHandler(values, { setSubmitting, setErrors }) {
        const { ownerUser, ...payload } = values;

        if (!(ownerUser && ownerUser.id)) {
            dispatch(notifyError("You have to select an owner user!"));
            setErrors({ ownerUser: "You have to select a client!" });
            return;
        }

        const apiCall = mode === "add" ? Flows.add : Flows.update;

        const payloadToSend = {
            ...payload,
            id: mode === "update" ? id : null,
            ownerUserId: ownerUser.id,
        };

        delete payloadToSend.tasks;

        setSubmitting(true);

        apiCall({
            payload: payloadToSend,
            onSuccess: (response) => onSuccess(response, setSubmitting),
            onError: (error) => onError(error, setSubmitting, setErrors),
        });
    }

    return (
        <Page>
            <Header title={(flow && flow.name) || "New Flow"} />
            {isLoading && <LoadingPage />}
            {!isLoading && ((mode !== "add" && flow) || mode === "add") && (
                <Form
                    data={flow}
                    resources={resources}
                    {...props}
                    onCancel={onCancelHandler}
                    onSubmit={onSubmitHandler}
                    onEdit={onEditHandler}
                    getFlow={getFlow}
                />
            )}
        </Page>
    );
}

Flow.propTypes = {
    mode: PropTypes.oneOf(["add", "detail", "update"]).isRequired,
    title: PropTypes.string,
};

export default withRouter(Flow);
